import { acceptTargetedAds } from '../actions/internalActions';
import { generateConsentString } from 'owa-gdpr-ad-consent-string';
import { orchestrator } from 'satcheljs';
import {
    GdprAdsV2Options,
    getOptionsForFeature,
    lazyCreateOrUpdateOptionsForFeature,
    OwsOptionsFeatureType,
} from 'owa-outlook-service-options';

orchestrator(acceptTargetedAds, async () => {
    const consentString = await generateConsentString(true, true, true, true, true, []);

    const savedOptions = getOptionsForFeature<GdprAdsV2Options>(OwsOptionsFeatureType.GdprAdsV2);

    const newOptions = {
        ...savedOptions,
        allowStorageAndAccess: true,
        allowAdSelectionDeliveryReporting: true,
        allowContentSelectionDeliveryReporting: true,
        allowPersonalization: true,
        allowMeasurement: true,
        disselectedVendorId: [],
        ...(consentString ? { consentString: consentString } : null),
    };

    return lazyCreateOrUpdateOptionsForFeature.importAndExecute(
        OwsOptionsFeatureType.GdprAdsV2,
        newOptions
    );
});
